import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { GeometryMapComponent } from './component/geometry-map/geometry-map.component';

@NgModule({
  declarations: [GeometryMapComponent], //SingleMarkerMapComponent
  imports: [CommonModule, MatIconModule, MatButtonModule], //AngularMaterialModule
  exports: [GeometryMapComponent], //SingleMarkerMapComponent
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: [] },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class GoogleMapModule {}
